// OMS Formatting Utilities

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
}

export function formatDate(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yy = String(date.getFullYear()).slice(-2)
  return `${dd}/${mm}/${yy}`
}

export function formatDateTime(dateString) {
  if (!dateString) return 'Never'
  const date = new Date(dateString)
  const dateStr = formatDate(dateString)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${dateStr} ${hours}:${minutes}`
}

export function formatPercentage(value, decimals = 3) {
  if (value === null || value === undefined) return '-'
  return `${value.toFixed(decimals)}%`
}

export function formatPrice(value, decimals = 3) {
  if (value === null || value === undefined) return '-'
  return `$${value.toFixed(decimals)}`
}